<template>
  <div>
    <RouterLink
      :to="post.slug"
      :aria-expanded="expanded.open"
      :aria-controls="post.slug"
      class="relative block flex-a p-x h-12 font-medium focus-b transition"
      :class="[
        expanded.open
          ? 'text-primary text-lg'
          : 'text-body b-b hover:bg-highlight-1',
        { 'b-b': !post.children.length && !post.description }
      ]"
    >
      <span class="flex-a h-full w-full">
        {{ htmlDecode(post.title) }}
      </span>
    </RouterLink>
    <Expand v-show="expanded.open" easing="ease-in">
      <div
        :id="post.slug"
        :aria-label="htmlDecode(post.title)"
        class="bg-white"
      >
        <p
          v-if="post.description"
          class="p-x pb-6 pt-1 mb-0 bg-grey-1"
          v-html="post.description"
        />
        <ul>
          <li
            v-for="item in post.children"
            :key="item.id"
            class="p-x border-b border-grey-1"
          >
            <button
              role="link"
              :tabindex="expanded.open ? 0 : -1"
              class="flex-a h-12 w-full text-primary focus-b"
              :data-gtm-sidebar-item="
                `360: ${post.title}, Title: ${item.title}, Type: ${item.type}`
              "
              @focus="$emit('handleFocus', item.slug)"
              @blur="$emit('handleBlur', item.slug)"
              @click="$emit('handleClick', item.slug)"
              @keyup.enter="$emit('handleEnter', item.slug)"
              @keyup.escape="$emit('handleEscape', item.slug)"
            >
              <IconBase :icon="`${item.type}icon`" size="1.2rem" class="mr-3" />
              {{ htmlDecode(item.title) }}
            </button>
          </li>
        </ul>
      </div>
    </Expand>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Expand from '@/components/utility/Expand.vue'
import IconBase from '@/components/icons/IconBase.vue'

export default {
  name: 'SidebarItem',

  components: {
    Expand,
    IconBase
  },

  props: {
    post: {
      type: Object,
      default: () => {}
    },
    expanded: {
      type: Object,
      default: () => {}
    },
    category: {
      type: Object,
      default: () => {}
    },
    isGuided: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState(['touch', 'mobile']),
    ...mapGetters([])
  }
}
</script>
